module.exports = __webpack_public_path__ + "static/media/illustration-aliamento.1a5c3a09.svg";